import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-driver-list-actions-dropdown',
  templateUrl: './driver-list-actions-dropdown.component.html',
  styleUrls: ['./driver-list-actions-dropdown.component.css']
})
export class DriverListActionsDropdownComponent implements OnInit {
  @Input() driver: any;
  @Output() onRouteChange = new EventEmitter<any>();
  @Output() onForceLogout = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

}
